import { Draw,Modify,Snap } from 'ol/interaction'
import { Vector as VectorSource } from 'ol/source'
import { Vector as VectorLayer } from 'ol/layer'
import { Style, Icon,Circle as CircleStyle,Fill} from 'ol/style'
export function ODraw(map,initSource, layerStyle) {
    let this_ = this;
    
    this_.mMap = map;
 
    this_.mSource = initSource;
    
    this_.mLayer = null;
 
    this_.mDraw = null;
    this_.mModify = null;
    this_.mSnap = null;
    this_.initialized = false;
    this_.layerStyle = layerStyle;
    if (!this_.initialized) {
        console.log("aaaaaaaa--------------------------------",(this_.mSource));
        ODraw.prototype.init = () => {
            if(!this_.mSource) {
                this_.mSource = new VectorSource();
            }
            this_.mLayer = new VectorLayer({
                title: "草图图层", // ol-ext图层控件属性
                noSwitcherDelete: true, // ol-ext图层控件属性
                source: this_.mSource, 
                // style:this_.layerStyle
            });
            if(this_.layerStyle) {
                this_.mLayer.setStyle(this_.layerStyle);
            }
            this_.mMap.addLayer(this_.mLayer);
 
 
            this_.mModify = new Modify({
                source: this_.mSource,
                // style: measureModifyStyle() // 自定义样式
                
            });
            console.log("this_.mSource========================",this_.mSource, this_.mMap);
            this_.mMap.addInteraction(this_.mModify);
        };
 
 
        ODraw.prototype.addInteractions = (drawType) => {
            this_.mDraw = new Draw({
                source: this_.mSource,
                type: drawType,
            });

            this_.mDraw.on('drawstart', function () {
                this_.mModify.setActive(false);
            });
            this_.mDraw.on('drawend', function () {
                this_.mModify.setActive(true);
            });
            this_.mModify.setActive(true);
            console.log("this_.mDraw=====================",this_.mDraw);
            this_.mMap.addInteraction(this_.mDraw);
 
            this_.mSnap = new Snap({
                source: this_.mSource
            });
            this_.mMap.addInteraction(this_.mSnap);
        };
 
        ODraw.prototype.removeInteractions = () => {
            this_.mDraw && this_.mMap.removeInteraction(this_.mDraw);
            this_.mSnap && this_.mMap.removeInteraction(this_.mSnap);
            this_.mModify && this_.mMap.removeInteraction(this_.mModify);
        };
 
        ODraw.prototype.startDraw = (drawType) => {
            this_.removeInteractions();
            this_.addInteractions(drawType);
        };
 
        ODraw.prototype.doneDraw = () => {
            this_.removeInteractions();
            // this_.mMap.getView().fit(this_.mSource.getExtent());
        };
 
        ODraw.prototype.clearDraw = () => {
            this_.mSource.clear();
        };
 
        this_.initialized = true;
    }
 
}